import { render } from "./FormWakalah.vue?vue&type=template&id=6af1434c&scoped=true&ts=true"
import script from "./FormWakalah.vue?vue&type=script&lang=tss"
export * from "./FormWakalah.vue?vue&type=script&lang=tss"

import "./FormWakalah.vue?vue&type=style&index=0&id=6af1434c&scoped=true&lang=scss"

import exportComponent from "/Users/bekircankaya/Documents/GitHub/kurban-vekalet-frontend-eski-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af1434c"]])

export default __exports__